import { render, staticRenderFns } from "./TrackingV2.vue?vue&type=template&id=80afe340&scoped=true&"
import script from "./TrackingV2.vue?vue&type=script&lang=js&"
export * from "./TrackingV2.vue?vue&type=script&lang=js&"
import style0 from "./TrackingV2.vue?vue&type=style&index=0&id=80afe340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80afe340",
  null
  
)

export default component.exports